<template>
  <v-row class="mt-0 pt-5" style="background-color: rgb(238, 238, 238)">
    <!-- <v-col
      cols="12"
      class="text-center py-1 mt-0"
      :class="{
        'pt-5': detailsExpanded,
        'grey lighten-2': !detailsExpanded,
      }"
    >
      <a
        @click="toggleDetails"
        class="text-uppercase font-weight-regular font-size--12"
        style="margin-top: -6px; color: #333 !important"
      >
        {{ detailsExpanded ? $t('L_hide_details') : $t('L_view_more_details') }}
        <v-icon
          style="margin-bottom: -4px"
          :icon="detailsExpanded ? mdiChevronDown : mdiChevronUp"
        />
      </a>
    </v-col> -->
    <v-row>
      <v-col cols="12" v-if="includeSpouseProp" class="pt-4 mt-2">
        <v-tabs grow v-model="selectedTab" color="primary" slider-color="#cecece">
          <v-tab color="black" @click="updateSelectedTabTop(0)">
            {{ $t('L_you') }}
          </v-tab>
          <v-tab color="black" @click="updateSelectedTabTop(1)">
            {{ $t('L_spouse') }}
          </v-tab>
        </v-tabs>
      </v-col>
      <v-col cols="12" sm="12">
        <Achievement />
      </v-col>
      <v-col cols="12" sm="12" class="mt-4">
        <ProgressCircle :progress="getProgressProp > 100 ? 100 : getProgressProp" :size="10" />
      </v-col>
      <v-col cols="12" sm="6">
        <GuidancePill
          :header="selectedTab === 0 ? $t('L_pill_you_have') : $t('L_pill_spouse_has')"
          :amount="``"
          :footer="$t('L_pill_in_protection')"
          class-string="offset-xs3 xs6"
        >
          <span>
            <span style="font-size: 1.2em">{{ formattedCurrentCoverageProp }}*</span>
          </span>
        </GuidancePill>
      </v-col>
      <v-col cols="12" sm="6">
        <GuidancePill
          :header="selectedTab === 0 ? $t('L_pill_you_need') : $t('L_pill_spouse_needs')"
          :amount="formattedNeedProp"
          :footer="$t('L_pill_in_life_insurance')"
          class-string="offset-xs3 xs6"
        />
      </v-col>
      <v-col cols="12" class="mt-0 pt-4 pb-6">
        <h4 class="text-h4 text-center cursor-pointer">
          <OnexButton
            id="how_did_we_calculate_m_trigger"
            variant="text"
            color="anchor"
            class="px-0"
            @click="dialogMobile = true"
          >
            {{ $t('L_how_did_we_calculate') }}
          </OnexButton>
        </h4>
      </v-col>
    </v-row>
    <v-col class="darkgraybkgrnd px-2">
      <!-- <h5 v-if="!detailsExpanded" class="text-h5 text-center">
        Add <span class="font-weight-medium">${{ formattedAdditionalProp }}</span> to be properly
        covered.
      </h5> -->
      <v-row v-if="detailsExpanded && additionalNeedProp > 0" class="mt-1">
        <v-col cols="12">
          <GuidancePill
            :header="$t('L_we_recommend_adding')"
            :amount="formattedAdditionalProp"
            :footer="$t('L_in_life_coverage')"
            class-string="offset-xs3 xs6"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-dialog v-model="dialogMobile" max-width="400" :fullscreen="$vuetify.display.xs">
      <v-card class="how_did_we_calculate_m_modal">
        <v-card-text class="font-weight-regular">
          <div v-html="$t('L_how_did_we_calculate_text')"></div>
          <div class="text-center mt-5 pb-14">
            <OnexButton class="bg-primary-lighten-2 mx-right" @click="dialogMobile = false">
              Got It
            </OnexButton>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import Achievement from '@/components/Achievement/Achievement.vue';
import ProgressCircle from '@/components/ProgressCircle/ProgressCircle.vue';
import { mdiChevronDown, mdiChevronUp } from '@mdi/js';
import GuidancePill from './GuidancePill.vue';
import { OnexButton } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'SidebarMobile',
  components: {
    GuidancePill,
    Achievement,
    ProgressCircle,
    OnexButton,
  },
  props: {
    includeSpouseProp: {
      type: Boolean,
      required: true,
      default: false,
    },
    getProgressProp: {
      type: Number,
      required: true,
      default: null,
    },
    formattedCurrentCoverageProp: {
      type: String,
      required: true,
      default: '',
    },
    formattedNeedProp: {
      type: String,
      required: true,
      default: '',
    },
    additionalNeedProp: {
      type: [Number, String],
      required: true,
      default: null,
    },
    formattedAdditionalProp: {
      type: [Number, String],
      required: true,
      default: null,
    },
    displayContactRep: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data: () => ({
    selectedTab: 0,
    dialogMobile: false,
    contactMeMobile: false,
    detailsExpanded: true,
    detailsHeight: 0,
    mdiChevronDown,
    mdiChevronUp,
  }),
  computed: {
    getMobileStyle() {
      return {
        'max-height': `${this.detailsHeight}px`,
      };
    },
  },
  methods: {
    updateSelectedTabTop(value: number) {
      this.$emit('updateSelectedTab', value);
    },
  },
  watch: {
    includeSpouseProp(newData) {
      if (newData === false) {
        this.updateSelectedTabTop(0);
        this.selectedTab = 0;
      }
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.darkgraybkgrnd {
  background-color: #e0e0e0 !important;
}
#mobile_footer {
  position: fixed;
  bottom: 0px;
  background-color: #e0e0e0 !important;
  left: 0;
  right: 0;
  z-index: 1;
  padding-bottom: 175px;
}
:deep(.v-btn--variant-text .v-btn__content) {
  white-space: normal;
}
</style>
